// extracted by mini-css-extract-plugin
export var buttonContent = "_2p-0";
export var centered = "_2p-1";
export var centeredFlex = "_2p-2";
export var errorText = "_2p-3";
export var icon = "_2p-4";
export var iconButtonContent = "_2p-5";
export var monospace = "_2p-6";
export var padded = "_2p-7";